module.exports = __webpack_public_path__ + "static/media/Beviani.460452e0.png";